import { CalendarNativeDateFormatter } from './calendarNativeDateFormatter.provider';

export class CalendarDateFormatter extends CalendarNativeDateFormatter {}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
